module.exports = __webpack_public_path__ + "img/location-singapore-3.6dcbe00d.jpg";